module.exports = __webpack_public_path__ + "static/media/kissa.fb8bbbe1.mp3";